import { LineDirectory, LineOrDirectoryPatch } from '@paragon/contract-library';

import { DesignService } from '../connections';

interface DirectoryCreationRequest {
  readonly name: string;
  readonly parentGuid?: string | null;
}

export function createDirectory(data: DirectoryCreationRequest): Promise<LineDirectory> {
  return DesignService.post('production/directories', { data });
}

export function patchDirectory(directoryGuid: string, patch: LineOrDirectoryPatch): Promise<LineDirectory> {
  return DesignService.patch(`production/directories/${directoryGuid}`, { data: patch });
}

export function deleteDirectory(directoryGuid: string): Promise<void> {
  return DesignService.delete(`production/directories/${directoryGuid}`);
}
